import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {RouterLink} from "@irati/ui/src/Link"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {PEOPLE} from "../../../../routes/routeConfig"

interface Props {}

const PeoplePageLink: FC<Props> = () => {
  const theme = useTheme()
  return (
    <Flex>
      <RouterLink cta to={PEOPLE}>
        <FormattedMessage id="admin.components.integrations.dsyncSetup.step2.link" />
      </RouterLink>
      <Icon icon={IconTypes.arrowRight} color={theme.colors.primary1} marginLeft={theme.spacing.one} />
    </Flex>
  )
}

export default PeoplePageLink
